import type { ReceiveLossesUrlState } from './types';

export const DEFAULT_URL_STATE: ReceiveLossesUrlState = {
  consignmentNumber: '',
  dateFrom: '',
  dateTo: '',
  search: '',
  // Date of loss, most recent first. (Sort field names are provisional until
  // the BE publishes its `sortBy` enum — see entities/receive/api/receiveLossesApi.)
  sortBy: 'lossDate',
  sortDir: 'DESC',
  size: '15'
};
